import { gql } from '@/__generated__';

export const RESEND_USER_CREDENTIALS = gql(`#graphql
  mutation ResendUserCredentials($input: ResendUserCredentialsInput!) {
    resendUserCredentials(input: $input) {
      success
    }
  }
`);
